import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'dux/app/hooks';

import isEmpty from 'lodash/fp/isEmpty';

import * as statuses from 'constants/statuses';

import { trackProductViewed } from 'dux/tracking/actions';
import { isFlagsDoneFetching } from 'dux/featureFlags/selectors';
import { getLastEditableSubscriptionAddress } from 'dux/subscriptions/selectors';

import { fetchProducts } from './actions';
import {
  getFetchedAccessoriesProductsMergedWithLocalProductsList,
  getFetchedHaircareProductsMergedWithLocalProductsList,
  getFetchedSkincareProductsMergedWithLocalProductsList,
  getProductsStatus,
} from './selectors';

export const useFetchProductsList = () => {
  const dispatch = useAppDispatch();
  const flagsDoneFetching = useAppSelector(isFlagsDoneFetching);
  const lastEditableSubscriptionAddress = useAppSelector(getLastEditableSubscriptionAddress);
  const status = useAppSelector(getProductsStatus);
  const accessoriesProducts = useAppSelector(
    getFetchedAccessoriesProductsMergedWithLocalProductsList
  );
  const haircareProducts = useAppSelector(getFetchedHaircareProductsMergedWithLocalProductsList);
  const skincareProducts = useAppSelector(getFetchedSkincareProductsMergedWithLocalProductsList);

  useEffect(() => {
    if (status === statuses.IDLE && flagsDoneFetching) {
      dispatch(fetchProducts(lastEditableSubscriptionAddress?.pubkey));
    }
  }, [lastEditableSubscriptionAddress, flagsDoneFetching, status]);

  const refetch = pubkey => dispatch(fetchProducts(pubkey));

  return {
    accessoriesProducts,
    haircareProducts,
    isLoaded: status === statuses.SUCCESS || status === statuses.ERROR,
    refetch,
    skincareProducts,
  };
};

export const useTrackProductViewed = ({ category, product, subcategory }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isEmpty(product)) {
      dispatch(
        trackProductViewed({
          category,
          subcategory,
          product,
        })
      );
    }
  }, [product]);
};
